// Kiid nutrition lightbox. Ported from the Dawn theme (product-widgets.js); uses the native <dialog>, no theme dependencies.
if (!customElements.get('kiid-nutrition-lightbox')) {
  customElements.define(
    'kiid-nutrition-lightbox',
    class NutritionLightbox extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        const openButton = this.querySelector('.kiid-nutrition-lightbox__open');
        openButton.addEventListener('click', () => {
          this.dialog.showModal();
          // Focus the dialog itself, not whatever the browser autofocuses (usually the
          // close button), so opening it doesn't show an unrelated-looking focus ring.
          this.dialog.focus();
        });
        this.querySelector('.kiid-nutrition-lightbox__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => openButton.focus());
        // A click on the dialog element itself (not its content) is a click on the backdrop.
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        this.panels = this.querySelectorAll('.kiid-nutrition-lightbox__panel');
        this.showFlavor(this.dataset.currentFlavor);

        const selector = this.querySelector('.kiid-nutrition-lightbox__selector');
        if (selector) selector.addEventListener('change', () => this.showFlavor(selector.value));
      }

      showFlavor(handle) {
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.flavor !== handle;
        });
      }
    }
  );
}
